import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from 'app-services-library';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class CustomNumberFieldService {
    constructor() { }
}
CustomNumberFieldService.ɵfac = function CustomNumberFieldService_Factory(t) { return new (t || CustomNumberFieldService)(); };
CustomNumberFieldService.ɵprov = i0.ɵɵdefineInjectable({ token: CustomNumberFieldService, factory: CustomNumberFieldService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomNumberFieldService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

function CustomNumberFieldComponent_em_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "em", 5);
    i0.ɵɵtext(1, "*");
    i0.ɵɵelementEnd();
} }
function CustomNumberFieldComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1, " Required ");
    i0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "width": a0 }; };
class CustomNumberFieldComponent {
    constructor(fb, appServicesLibraryService) {
        this.fb = fb;
        this.appServicesLibraryService = appServicesLibraryService;
    }
    ngOnInit() {
        let numFieldVal_data = (this.inputParams.value) ? this.inputParams.value : '';
        const numberFieldValidators = this.inputParams.mandatory ? [Validators.required] : [];
        this.group.addControl(this.inputParams.name, this.fb.control(numFieldVal_data, numberFieldValidators));
    }
    onNumberInputChange(event) {
        this.group.controls[this.inputParams.name].patchValue(event.target.value);
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
CustomNumberFieldComponent.ɵfac = function CustomNumberFieldComponent_Factory(t) { return new (t || CustomNumberFieldComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.AppServicesLibraryService)); };
CustomNumberFieldComponent.ɵcmp = i0.ɵɵdefineComponent({ type: CustomNumberFieldComponent, selectors: [["lib-custom-number-field"]], inputs: { formControlName: "formControlName", value: "value", inputParams: "inputParams", group: "group" }, decls: 7, vars: 9, consts: [[1, "text-field", 3, "formGroup"], [1, "label-cls", "d-block"], [1, "common-bene-class-for-translation"], ["class", "error", 4, "ngIf"], ["type", "number", "aria-label", "inputParams?.label", 1, "form-control", 2, "width", "100%", 3, "formControlName", "input"], [1, "error"]], template: function CustomNumberFieldComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "label", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CustomNumberFieldComponent_em_4_Template, 2, 0, "em", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "input", 4);
        i0.ɵɵlistener("input", function CustomNumberFieldComponent_Template_input_input_5_listener($event) { return ctx.onNumberInputChange($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(6, CustomNumberFieldComponent_span_6_Template, 2, 0, "span", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵstyleMap(i0.ɵɵpureFunction1(7, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width));
        i0.ɵɵproperty("formGroup", ctx.group);
        i0.ɵɵadvance(3);
        i0.ɵɵtextInterpolate(ctx.inputParams == null ? null : ctx.inputParams.label);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputParams == null ? null : ctx.inputParams.mandatory);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("formControlName", ctx.formControlName);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.inputParams == null ? null : ctx.inputParams.mandatory) && ctx.group.get(ctx.inputParams.name).touched && ctx.group.get(ctx.inputParams.name).hasError("required"));
    } }, directives: [i1.NgControlStatusGroup, i1.FormGroupDirective, i3.NgIf, i1.NumberValueAccessor, i1.DefaultValueAccessor, i1.NgControlStatus, i1.FormControlName], styles: [".error[_ngcontent-%COMP%]{font-size:12px;color:#e31302;padding-top:3px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomNumberFieldComponent, [{
        type: Component,
        args: [{
                selector: 'lib-custom-number-field',
                templateUrl: 'custom-number-field.component.html',
                styleUrls: ['custom-number-field.component.scss']
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.AppServicesLibraryService }]; }, { formControlName: [{
            type: Input
        }], value: [{
            type: Input
        }], inputParams: [{
            type: Input
        }], group: [{
            type: Input
        }] }); })();

class CustomNumberFieldModule {
}
CustomNumberFieldModule.ɵfac = function CustomNumberFieldModule_Factory(t) { return new (t || CustomNumberFieldModule)(); };
CustomNumberFieldModule.ɵmod = i0.ɵɵdefineNgModule({ type: CustomNumberFieldModule });
CustomNumberFieldModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(CustomNumberFieldModule, { declarations: [CustomNumberFieldComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule], exports: [CustomNumberFieldComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CustomNumberFieldModule, [{
        type: NgModule,
        args: [{
                declarations: [CustomNumberFieldComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [CustomNumberFieldComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of custom-number-field
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CustomNumberFieldComponent, CustomNumberFieldModule, CustomNumberFieldService };
//# sourceMappingURL=custom-number-field.js.map
